import React from 'react';
import { backdropAnim, modalAnim } from '../motion/keyframes.js';

// Survey-shaped skeleton, painted instantly when chirp:survey:open arrives so the
// user gets visual feedback before the lazy renderer chunk resolves and the survey
// payload arrives. Matches the rough modal layout of <SurveyShell> so the swap to
// the real renderer doesn't reflow heavily.
export const SurveySkeleton: React.FC = () => {
  return (
    <div role="dialog" aria-busy="true" aria-label="Loading survey" style={backdropStyle}>
      <div style={cardStyle}>
        <div style={{ ...barStyle, width: '60%', height: 22, marginBottom: 12 }} />
        <div style={{ ...barStyle, width: '40%', height: 14, marginBottom: 32 }} />
        <div style={{ ...barStyle, width: '100%', height: 56, marginBottom: 12 }} />
        <div style={{ ...barStyle, width: '100%', height: 56, marginBottom: 32 }} />
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{ ...barStyle, width: 96, height: 36 }} />
        </div>
      </div>
    </div>
  );
};

const backdropStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(15, 23, 42, 0.45)',
  animation: backdropAnim(),
  padding: 16,
};

const cardStyle: React.CSSProperties = {
  width: '100%',
  maxWidth: 520,
  background: '#ffffff',
  borderRadius: 16,
  padding: '32px 28px',
  boxShadow: '0 10px 40px rgba(15, 23, 42, 0.18)',
  animation: modalAnim(),
};

const barStyle: React.CSSProperties = {
  background: '#e5e7eb',
  borderRadius: 8,
  animation: 'chirp-skeleton 1.4s ease-in-out infinite',
};
